// Data for products, gallery, and services scraped from HJ3DDesign

export const deluxBoxes = [
  {
    id: "delux-1",
    name: "DELUX Kasse – Sort m. Gult Håndtag",
    category: "Øl kasser med logo",
    description: "Fuldprintet minikasse i stilren sort med guldgult bærehåndtag og flot detaljegrad.",
    price: "Forespørg pris",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/c719a8bc-7890-402d-862b-de9266e7766c.jpg",
    tag: "Sort / Gul",
    popular: true,
    newArrival: true,
  },
  {
    id: "delux-2",
    name: "DELUX Kasse – Sort m. Integreret Greb",
    category: "Øl kasser med logo",
    description: "Robust sort bærekasse med integreret håndtag og præcist udskåret finish.",
    price: "Forespørg pris",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/8ac16670-1865-4bc6-99ff-85e488265deb.jpg",
    tag: "Integreret greb",
    popular: true,
    newArrival: true,
  },
  {
    id: "delux-3",
    name: "DELUX Kasse – Pink m. Gult Håndtag",
    category: "Øl kasser med logo",
    description: "Flot pink opbevaringskasse med gult opretstående håndtag og mulighed for personlig tekst.",
    price: "Forespørg pris",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/585bb1d5-e224-4bbd-8fa7-fa7fa5b2bd7c.jpg",
    tag: "Pink / Gul",
    popular: true,
    newArrival: true,
  },
  {
    id: "delux-4",
    name: "DELUX Kasse – Rød m. Hvidt Håndtag",
    category: "Øl kasser med logo",
    description: "Specialprintet rød kasse med hvidt bærehåndtag og dynamiske sportsdetaljer.",
    price: "Forespørg pris",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/9eea0002-6f9c-458d-a305-f39d4f7140ff.jpg",
    tag: "Rød / Hvid",
    popular: true,
    newArrival: true,
  },
  {
    id: "delux-5",
    name: "DELUX Kasse – Gul m. Blåt Håndtag",
    category: "Øl kasser med logo",
    description: "Frisk gul minikasse med blåt håndtag og tilbehør i skarpe kontrastfarver.",
    price: "Forespørg pris",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/56a2dd3a-8822-429f-ac4e-697285f8f0db.jpg",
    tag: "Gul / Blå",
    popular: true,
    newArrival: true,
  },
  {
    id: "delux-6",
    name: "DELUX Kasse – Hvid m. Guld Håndtag",
    category: "Øl kasser med logo",
    description: "Elegant hvid miniaturekasse med guldhåndtag til f.eks. gaver, jubilæum og mærkedage.",
    price: "Forespørg pris",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/35a92cbc-c00b-45f9-b259-3b7decd8b754.jpg",
    tag: "Hvid / Guld",
    popular: true,
    newArrival: true,
  },
  {
    id: "delux-7",
    name: "DELUX Kasse – Mørkegrøn m. Holdere",
    category: "Øl kasser med logo",
    description: "Specialbygget mørkegrøn kasse med sølvfarvet håndtag og integrerede indsatser.",
    price: "Forespørg pris",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/4dbdb297-51e7-4a10-b01f-1c9be90efdd5.jpg",
    tag: "Specialholder",
    popular: true,
    newArrival: true,
  },
  {
    id: "delux-8",
    name: "DELUX Kasse – Rød m. Sportstema",
    category: "Øl kasser med logo",
    description: "Flot rød bære- og opbevaringskasse med hvidt håndtag og skarp tofarvet grafik.",
    price: "Forespørg pris",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/50c720de-a6e1-4a70-b03d-f9ea71e59a8e.jpg",
    tag: "Rød / Sport",
    popular: true,
    newArrival: true,
  },
  {
    id: "delux-9",
    name: "DELUX Kasse – Skovgrøn m. Sølvdetaljer",
    category: "Øl kasser med logo",
    description: "Mørkegrøn kasse med sølvfarvet håndtag, dåseholdere og præcise indsatser.",
    price: "Forespørg pris",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/0dd2c729-25e7-49c7-a9be-8fcafe3138d3.jpg",
    tag: "Grøn / Sølv",
    popular: true,
    newArrival: true,
  },
];

export const products = [
  ...deluxBoxes,
  {
    id: 78,
    name: "12 Pack Underberg Kasse",
    category: "Kasser",
    description: "Specialdesignet kasse med plads til 12 flasker Underberg.",
    price: "89 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image0-4.webp",
    popular: true,
    newArrival: true,
  },
  {
    id: 79,
    name: "6 Pack Underberg Kasse med Håndtag",
    category: "Kasser",
    description: "Bærekasse til 6 Underberg flasker med integreret håndtag.",
    price: "59 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-5502.webp",
    popular: true,
    newArrival: false,
  },
  {
    id: 80,
    name: "6 Pack Underberg Kasse",
    category: "Kasser",
    description: "Klassisk 6-stk Underberg opbevaringskasse.",
    price: "49 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image0-1.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 780,
    name: "Ølkasse med logo / personlig tekst",
    category: "Kasser",
    description: "Specialfremstillet 3D-printet ølkasse med valgfrit logo, firmanavn eller personlig tekst.",
    price: "Fra 89 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image0-4.webp",
    popular: true,
    newArrival: true,
  },
  {
    id: 1,
    name: "Vase 19 cm",
    category: "Lys / Lamper",
    description: "Elegant 3D-printet vase på 19 cm. Kan tilpasses i farve efter dit ønske.",
    price: "149 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/products.webp",
    popular: true,
    newArrival: false,
  },
  {
    id: 2,
    name: "Vase 10 cm",
    category: "Lys / Lamper",
    description: "Kompakt og stilren vase på 10 cm til tørrede blomster eller pynt.",
    price: "49 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/2aa1d76c-902a-4449-830d-bd57dcd835d1.webp",
    popular: false,
    newArrival: true,
  },
  {
    id: 3,
    name: "Vase 12 cm",
    category: "Lys / Lamper",
    description: "Flot dekorativ vase på 12 cm med moderne geometrisk form.",
    price: "69 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/3e20f788-5f77-4ce9-a042-678c3f1cf4ea.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 4,
    name: "Vase sæt 13-11 cm",
    category: "Lys / Lamper",
    description: "Harmonisk sæt med 2 vaser i henholdsvis 13 cm og 11 cm højde.",
    price: "149 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/c7e06ae8-0d18-4773-ab67-2fa14269ac93.webp",
    popular: true,
    newArrival: false,
  },
  {
    id: 5,
    name: "Familie Med 1 Barn 17 cm",
    category: "Figurer",
    description: "Smuk personlig familieskulptur med mor, far og 1 barn (17 cm).",
    price: "149 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image0-3.webp",
    popular: true,
    newArrival: true,
  },
  {
    id: 6,
    name: "Familie 2 Børn 17 cm",
    category: "Figurer",
    description: "Hjertevarm familieskulptur med 2 børn (17 cm) til hjemmet.",
    price: "169 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/skaermbillede-2025-08-24-191355.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 7,
    name: "Familie 3 Børn 17 cm",
    category: "Figurer",
    description: "Detaljeret familieskulptur med 3 børn (17 cm) i ønsket farve.",
    price: "179 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/skaermbillede-2025-08-24-191311.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 8,
    name: "Familie 4 Børn 17 cm",
    category: "Figurer",
    description: "Flot stor familieskulptur med 4 børn (17 cm).",
    price: "199 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/skaermbillede-2025-08-24-191127.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 9,
    name: "Lysestager Lille / Stor",
    category: "Lys / Lamper",
    description: "Stilrene lysestager. Lille: 39 kr. / Stor: 49 kr.",
    price: "Fra 39 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/6ebb9be5-da2b-4687-b914-047293eacd06.webp",
    popular: true,
    newArrival: false,
  },
  {
    id: 10,
    name: "Lysestage",
    category: "Lys / Lamper",
    description: "Enkel og elegant lysestage til hyggelig belysning.",
    price: "35 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/1eb83007-ae32-4031-b0d3-bf26d30bfc7a.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 11,
    name: "Lysestager sæt",
    category: "Lys / Lamper",
    description: "Komplet sæt lysestager i moderne dansk design.",
    price: "89 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image0.webp",
    popular: false,
    newArrival: true,
  },
  {
    id: 12,
    name: "Lysestager",
    category: "Lys / Lamper",
    description: "Klassiske lysestager til bloklys og kronelys.",
    price: "49 kr. pr. stk",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-5425.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 13,
    name: "Sløjfe lysestager",
    category: "Lys / Lamper",
    description: "Dekorativ lysestage med unikt sløjfe-motiv.",
    price: "39 kr./stk",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-att-ai5w-mu6qvwpkwkt2jujqyds0t1g-yvdqlcvcd8zdh4.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 14,
    name: "Fyrfadsstage",
    category: "Lys / Lamper",
    description: "Hyggelig fyrfadsstage med flot lysspil og mønster.",
    price: "59 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/skaermbillede-2025-08-25-171344.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 15,
    name: "Lysestager til fyrfads- og alm. lys",
    category: "Lys / Lamper",
    description: "Fleksibelt lysestagesæt til både fyrfadslys og almindelige stearinlys.",
    price: "69 kr./sæt",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image4-1.webp",
    popular: false,
    newArrival: true,
  },
  {
    id: 16,
    name: "Smykkeæske",
    category: "WC/Udstyr",
    description: "Fin og praktisk smykkeæske til ringe, øreringe og småting.",
    price: "39 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/skaermbillede-2025-08-25-174713.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 17,
    name: "Gavebox 6,7x9,7 cm",
    category: "Gavebox",
    description: "Kompakt gaveæske i mål 6,7 x 9,7 cm til gaver og opbevaring.",
    price: "45 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-5776.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 18,
    name: "Gavebox",
    category: "Gavebox",
    description: "Flot gaveæske med præcist låg og dekorativ finish.",
    price: "129 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/skaermbillede-2025-08-24-205742.webp",
    popular: true,
    newArrival: false,
  },
  {
    id: 19,
    name: "Gavebox L21-B14-H4 cm",
    category: "Gavebox",
    description: "Rummelig rektangulær gavebox i mål L21 x B14 x H4 cm.",
    price: "149 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image0-10.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 20,
    name: "Garnkurv",
    category: "Andet",
    description: "Praktisk garnholder og strikkekurv der holder styr på garnet.",
    price: "99 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/skaermbillede-2025-08-25-233742.webp",
    popular: false,
    newArrival: true,
  },
  {
    id: 21,
    name: "Omgangstæller og Strikkepindemåler Sæt",
    category: "Andet",
    description: "Uundværligt sæt til strikkeentusiasten med præcise mål og tæller.",
    price: "39 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image0-7.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 22,
    name: "Krukke med låg",
    category: "WC/Udstyr",
    description: "Fin opbevaringskrukke med tætsluttende låg til nips.",
    price: "45 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image1-1.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 222,
    name: "Krukke med låg",
    category: "WC/Udstyr",
    description: "Fin opbevaringskrukke med tætsluttende låg til nips.",
    price: "45 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image4.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 23,
    name: "WC skilt 9 cm",
    category: "WC/Udstyr",
    description: "Tydeligt og stilrent toiletskilt på 9 cm til dør eller væg.",
    price: "25 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-5430.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 24,
    name: "Toiletrulleholder",
    category: "WC/Udstyr",
    description: "Funktionel og moderne toiletrulleholder i slidstærkt print.",
    price: "29 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image0-5_69cbea4e.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 240,
    name: "Toiletrulleholder",
    category: "WC/Udstyr",
    description: "Funktionel og moderne toiletrulleholder i slidstærkt print.",
    price: "39 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image1-3.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 241,
    name: "Toiletrulleholder",
    category: "WC/Udstyr",
    description: "Funktionel og moderne toiletrulleholder i slidstærkt print.",
    price: "29 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-5693.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 242,
    name: "Toiletrulleholder",
    category: "WC/Udstyr",
    description: "Funktionel og moderne toiletrulleholder i slidstærkt print.",
    price: "29 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-5694.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 25,
    name: "Toiletrulleholder med Julehue",
    category: "WC/Udstyr",
    description: "Sjov og festlig toiletrulleholder med julehue til december.",
    price: "39 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image2-5.webp",
    popular: false,
    newArrival: true,
  },
  {
    id: 26,
    name: "Toiletrulleholder Nytårshat",
    category: "WC/Udstyr",
    description: "Festlig toiletrulleholder med nytårshat.",
    price: "39 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image0-25.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 27,
    name: "Toiletrulleholder Hat med stjerner",
    category: "WC/Udstyr",
    description: "Dekorativ toiletrulleholder med stjerne-hat.",
    price: "29 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image1-8.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 271,
    name: "Toiletrulleholder",
    category: "WC/Udstyr",
    description: "Funktionel og moderne toiletrulleholder i slidstærkt print.",
    price: "29 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-2036.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 28,
    name: "Roterende børste / Tusch Holder",
    category: "WC/Udstyr",
    description: "Smart 360-graders roterende holder til sminkebørster eller tuscher.",
    price: "129 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image2-2.webp",
    popular: true,
    newArrival: false,
  },
  {
    id: 29,
    name: "Smykkebakke med beholder",
    category: "WC/Udstyr",
    description: "Elegant sæt med smykkebakke og tilhørende opbevaringsbeholder.",
    price: "69 kr. sæt",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image0-11.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 30,
    name: "Toilet organizer",
    category: "WC/Udstyr",
    description: "Praktisk organizer til badeværelset der holder orden.",
    price: "49 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image3-1.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 31,
    name: "Badeværelsessæt til vatpinde og vatrondeller",
    category: "WC/Udstyr",
    description: "Specialdesignet sæt til hygiejnisk opbevaring af vatpinde og ovale vatrondeller.",
    price: "99 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/img-1891.webp",
    popular: false,
    newArrival: true,
  },
  {
    id: 32,
    name: "Skilte til thermokander",
    category: "Køkken/Udstyr",
    description: "Tydelige hængeskilte til kaffe- og tekander. Bestil med ønsket tekst.",
    price: "10 kr./stk",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1994.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 33,
    name: "Flaskeholder til tørring",
    category: "Køkken/Udstyr",
    description: "Praktisk tørrestativ til drikkedunke og sutteflasker.",
    price: "25 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-5730.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 34,
    name: "Æggebæger",
    category: "Køkken/Udstyr",
    description: "Farverige og personlige æggebægre til morgenbordet.",
    price: "29 kr. pr. stk",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-2094.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 35,
    name: "Julepynt ophæng",
    category: "Andet",
    description: "Smukke 3D-printede ophæng til juletræet og vinduet.",
    price: "Fra 10 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1555.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 36,
    name: "Julepynt 15-19 cm",
    category: "Andet",
    description: "Flot juledekoration. 15 cm: 49 kr. / 19 cm: 89 kr. / Begge for 125 kr.",
    price: "Fra 49 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/image0-1.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 37,
    name: "Julepynt Snemand 14 cm",
    category: "Figurer",
    description: "Sød og detaljeret snemand på 14 cm til julebordet.",
    price: "69 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1549.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 38,
    name: "Julepynt Kirke 10 cm",
    category: "Figurer",
    description: "Stemningsfuld kirke med fine arkitektoniske detaljer (10 cm).",
    price: "39 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1550.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 39,
    name: "Julepynt Engel 16 cm",
    category: "Figurer",
    description: "Elegant engel på 16 cm i hvidt eller perlemors-filament.",
    price: "69 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1551.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 40,
    name: "Julepynt Juletræ 11 cm",
    category: "Figurer",
    description: "Moderne geometrisk juletræ på 11 cm.",
    price: "19 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1552.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 41,
    name: "Store champignon efterårspynt",
    category: "Figurer",
    description: "Flotte store dekorationssvampe til efterårshygge i stuen.",
    price: "179 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/image3.webp",
    popular: true,
    newArrival: true,
  },
  {
    id: 42,
    name: "Julepynt med batterilys",
    category: "Lys / Lamper",
    description: "Hyggelig julepynt oplyst med indbygget sikkert LED-lys.",
    price: "99 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image2-3.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 43,
    name: "Nisse 17 cm",
    category: "Figurer",
    description: "Klassisk dansk nissefigur i 17 cm højde.",
    price: "45 kr. pr. stk",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1793.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 44,
    name: "Nisse 19 cm",
    category: "Figurer",
    description: "Højere nissefigur på 19 cm med masser af charme.",
    price: "49 kr. pr. stk",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1792.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 45,
    name: "Juletræsophæng med valgfrit navn",
    category: "Andet",
    description: "Gør julen personlig – få printet familiens navne på juleophæng.",
    price: "15 kr. stk",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image0-15.webp",
    popular: true,
    newArrival: true,
  },
  {
    id: 46,
    name: "Servietholdere (6 stk)",
    category: "Køkken/Udstyr",
    description: "Sæt med 6 matchende servietholdere til festbordet.",
    price: "Fra 29 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image2-4.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 47,
    name: "Moderne juletræ med nisser",
    category: "Figurer",
    description: "Stilrent juletræ med søde integrerede nisser.",
    price: "Fra 69 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-att-mvelgry0b8j1pgrom7yqb6t5rfay3tkw3osook-ihhm.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 48,
    name: "Søde nisser med hængende ben",
    category: "Figurer",
    description: "Charmerende nisser, der kan sidde på reolkanten med benene hængende.",
    price: "69 kr./stk",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1991.webp",
    popular: true,
    newArrival: true,
  },
  {
    id: 49,
    name: "Rensdyr 13-17 cm",
    category: "Figurer",
    description: "Flotte rensdyrfigurer i 13 cm eller 17 cm højde.",
    price: "Fra 49 kr./stk",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1879.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 50,
    name: "Påskepynt",
    category: "Andet",
    description: "Farverigt forårspynt og påskeharer til højtiden.",
    price: "Fra 15 kr./stk",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/att-tgljtvt1pfffeh6dmuxygf2-ahqzgemifau1wnkh9qc.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 51,
    name: "Hjerte skulptur",
    category: "Figurer",
    description: "Smuk hjerteskulptur til boligen eller som kærlig gave.",
    price: "29 kr./stk",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-2144.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 52,
    name: "Par med Hjerte",
    category: "Figurer",
    description: "Romantisk skulptur af et forelsket par med et hjerte.",
    price: "99 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-att-s2lobbpelwwalicmu2s9-lkavxhwcd7zmnd8lkdmodw.webp",
    popular: true,
    newArrival: false,
  },
  {
    id: 53,
    name: "Par skulptur",
    category: "Figurer",
    description: "Stilren og abstrakt skulptur af et par (89 kr./stk).",
    price: "89 kr./stk",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-2131.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 54,
    name: "Øreringe m. 925 sterling sølv kroge",
    category: "Andet",
    description: "Lette og unikke 3D-printede øreringe monteret med ægte sølvkroge.",
    price: "35 kr. sæt",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image0-5.webp",
    popular: false,
    newArrival: true,
  },
  {
    id: 55,
    name: "Pokal 11-19 cm",
    category: "Andet",
    description: "Skræddersyede pokaler til stævner og sjove turneringer (11, 15 el. 19 cm).",
    price: "65 - 85 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/skaermbillede-2025-08-31-233434.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 56,
    name: "Dragon Egg",
    category: "Figurer",
    description: "Detaljeret drageæg med skælmønster og flot tekstur.",
    price: "49 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-5728-6.webp",
    popular: true,
    newArrival: false,
  },
  {
    id: 57,
    name: "Hägar figur",
    category: "Figurer",
    description: "Flot håndværk – den kendte Hägar the Horrible vikingefigur.",
    price: "299 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-0854.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 58,
    name: "Lego hoveder til batteri fyrfadslys",
    category: "Lys / Lamper",
    description: "Ikoniske Lego-hoveder der lyser op med LED-fyrfadslys.",
    price: "169 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/skaermbillede-2025-10-09-104956.webp",
    popular: true,
    newArrival: false,
  },
  {
    id: 59,
    name: "Stitch & Lilo sæt",
    category: "Figurer",
    description: "Søde Stitch og Lilo figurer (Lille 25 kr / Mellem 50 kr / Stor 75 kr).",
    price: "25 - 75 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-5424.webp",
    popular: false,
    newArrival: true,
  },
  {
    id: 60,
    name: "Anders And 17 cm",
    category: "Figurer",
    description: "Klassisk og detaljeret Anders And figur på 17 cm.",
    price: "119 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1662.webp",
    popular: true,
    newArrival: false,
  },
  {
    id: 61,
    name: "Andersine 17 cm",
    category: "Figurer",
    description: "Smuk Andersine figur på 17 cm med fine farvedetaljer.",
    price: "119 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1665.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 62,
    name: "Rip / Rap / Rup 12 cm",
    category: "Figurer",
    description: "De tre frække nevøer i 12 cm højde.",
    price: "129 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1676.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 63,
    name: "Onkel Joakim",
    category: "Figurer",
    description: "Onkel Joakim med høj hat og spadserestok.",
    price: "125 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1679.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 64,
    name: "Mickey Mouse 17 cm",
    category: "Figurer",
    description: "Den elskede Mickey Mouse figur i 17 cm højde.",
    price: "119 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1664.webp",
    popular: true,
    newArrival: false,
  },
  {
    id: 65,
    name: "Minnie Mouse 17 cm",
    category: "Figurer",
    description: "Klassisk Minnie Mouse med prikket kjole og sløjfe (17 cm).",
    price: "119 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1669.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 66,
    name: "Baby Mickey / Baby Minnie Mouse",
    category: "Figurer",
    description: "Nuttede babyudgaver af Mickey og Minnie Mouse.",
    price: "99 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1678.webp",
    popular: false,
    newArrival: true,
  },
  {
    id: 67,
    name: "Pluto 17 cm",
    category: "Figurer",
    description: "Mickeys trofaste hund Pluto i 17 cm højde.",
    price: "119 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1667.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 68,
    name: "Goofy 17 cm",
    category: "Figurer",
    description: "Den glade og klodsede Fedtmule figur i 17 cm.",
    price: "119 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1673.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 69,
    name: "Clarabella 17 cm",
    category: "Figurer",
    description: "Klassisk Clarabella Ko figur i 17 cm.",
    price: "119 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1686.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 70,
    name: "Max Goof 17 cm",
    category: "Figurer",
    description: "Fedtmules søn Max Goof i 17 cm.",
    price: "119 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1687.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 71,
    name: "Goofy 35 cm",
    category: "Figurer",
    description: "Ekstra stor Fedtmule figur på hele 35 cm.",
    price: "225 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/img-1507.webp",
    popular: true,
    newArrival: false,
  },
  {
    id: 72,
    name: "Minecraft legofigur 23 cm (bevægelige arme & ben)",
    category: "Figurer",
    description: "23 cm høj Minecraft-inspireret figur med fuldt bevægelige arme og ben.",
    price: "189 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image0-20.webp",
    popular: true,
    newArrival: true,
  },
  {
    id: 73,
    name: "Øl kop",
    category: "Andet",
    description: "Sjov 3D-printet ølkop-holder eller dekorationskop.",
    price: "39 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-5427.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 74,
    name: "Sodavand kop",
    category: "Andet",
    description: "Dekorativ sodavandskop printet i flotte farver.",
    price: "39 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-5426.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 75,
    name: "Breezer kop",
    category: "Andet",
    description: "Specialtilpasset Breezer kop til fester og events.",
    price: "39 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-5428.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 76,
    name: "Kopper med navn",
    category: "Andet",
    description: "Gør koppen personlig med indgraveret eller printet navn.",
    price: "39 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-5429.webp",
    popular: false,
    newArrival: true,
  },
  {
    id: 77,
    name: "Batteri opbevaring",
    category: "Andet",
    description: "Praktisk organiser til AA og AAA batterier så der altid er orden.",
    price: "49 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image0-8.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 81,
    name: "Sparebøsse",
    category: "Andet",
    description: "Robust og sjov sparebøsse i 3D-print.",
    price: "59 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image0-6.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 82,
    name: "Penneholder",
    category: "Andet",
    description: "Flot penneholder til skrivebordet, der holder orden på kuglepenne.",
    price: "45 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image0-9.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 83,
    name: "Gaming skilt",
    category: "Andet",
    description: "Tjekket vægskilt til gamer-værelset eller computeropsætningen.",
    price: "59 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image0-21.webp",
    popular: true,
    newArrival: true,
  },
  {
    id: 84,
    name: "Navneskilt 25x5,5 cm",
    category: "Andet",
    description: "Personligt navneskilt i mål 25 x 5,5 cm til dør, værelse eller kontor.",
    price: "50 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-5767.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 85,
    name: "Husnummer 24 cm",
    category: "Andet",
    description: "Store, vejrbestandige husnumre på 24 cm i moderne skrifttype.",
    price: "69 kr. pr. tal",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1556.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 86,
    name: "Spiral Fidget",
    category: "Andet",
    description: "Beroligende og underholdende spiral fidget legetøj i forskellige størrelser.",
    price: "15 - 25 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image5.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 87,
    name: "Kaffe / Te skilt",
    category: "Køkken/Udstyr",
    description: "Hyggeligt skilt til kaffehjørnet eller tekøkkenet.",
    price: "39 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image6.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 88,
    name: "Tea Time skilt",
    category: "Køkken/Udstyr",
    description: "Dekorativt vægskilt til te-elskeren.",
    price: "19 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image0-23.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 89,
    name: "Coffee skilt",
    category: "Køkken/Udstyr",
    description: "Moderne 'Coffee' kaffeskilt til køkkenet.",
    price: "19 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image1-7.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 90,
    name: "Milwaukee holder til maskiner & batteri 18V",
    category: "Andet",
    description: "Solid vægholder til Milwaukee 18V værktøj og batterier.",
    price: "59 kr. sæt",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1812.webp",
    popular: true,
    newArrival: true,
  },
  {
    id: 91,
    name: "Dart Oche",
    category: "Andet",
    description: "Præcis kaste-linje / Oche til dartentusiasten.",
    price: "100 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1685-7.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 92,
    name: "Visitkortholder",
    category: "Andet",
    description: "Professionel holder til visitkort på skrivebordet eller receptionen.",
    price: "39 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image2.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 93,
    name: "Nøgleophæng",
    category: "Andet",
    description: "Praktisk nøglebræt og ophæng til entréen.",
    price: "99 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/img-1900.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 94,
    name: "Scania Nøglering",
    category: "Nøgleringe",
    description: "Flot 3D-printet nøglering med Scania logo.",
    price: "25 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1831.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 95,
    name: "Scania Griff Nøglering",
    category: "Nøgleringe",
    description: "Scania Griffen som detaljeret nøglering.",
    price: "25 kr.",
    image: "/imgi_725_thumbnail_IMG_1832.jpg",
    popular: false,
    newArrival: false,
  },
  {
    id: 96,
    name: "V8 Nøglering",
    category: "Nøgleringe",
    description: "Klassisk V8 emblem nøglering i høj finish.",
    price: "25 kr.",
    image: "/imgi_727_thumbnail_IMG_1837.jpg",
    popular: false,
    newArrival: false,
  },
  {
    id: 97,
    name: "Taske- & Nøgleringe",
    category: "Nøgleringe",
    description: "Personlige vedhæng og nøgleringe til skoletasker og nøgler.",
    price: "25 kr./stk",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image0-16.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 98,
    name: "Pikachu",
    category: "Nøgleringe",
    description: "Ikonisk Pikachu figur / vedhæng i flot gul farve.",
    price: "25 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image0-18.webp",
    popular: true,
    newArrival: false,
  },
  {
    id: 99,
    name: "BMW Nøglering",
    category: "Nøgleringe",
    description: "Stilren BMW nøglering med skarpe detaljer.",
    price: "25 kr./stk",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1942.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 100,
    name: "Puslespil",
    category: "Andet",
    description: "Unikt 3D-printet puslespil og hjernevriderspil.",
    price: "129 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/image0-2.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 101,
    name: "Kryds & Bolle Spil",
    category: "Andet",
    description: "Kompakt og sjovt rejsespil i flot design.",
    price: "25 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-2236.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 102,
    name: "And til anhængertræk",
    category: "Andet",
    description: "Sjov beskyttelseshætte formet som en and til bilens anhængertræk.",
    price: "59 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-2067.webp",
    popular: true,
    newArrival: true,
  },
  {
    id: 103,
    name: "Kortholder",
    category: "Andet",
    description: "Praktisk kortholder til betalingskort, ID og adgangskort.",
    price: "35 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-2172.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 104,
    name: "Saltske",
    category: "Andet",
    description: "Specialdesignet ske til salt og krydderier i køkkenet.",
    price: "99 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-2246.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 105,
    name: "Stor Clips / Bogmærke",
    category: "Andet",
    description: "Stor dekorativ clips (25 kr./stk) eller bogmærke (10 kr./stk).",
    price: "Fra 10 kr.",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-2173.webp",
    popular: false,
    newArrival: false,
  },
  {
    id: 106,
    name: "Poseholder til IKEA skraldespand",
    category: "Andet",
    description: "Specialtilpasset klemme/holder der holder posen på plads i IKEA skraldespande.",
    price: "Kontakt for pris",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/dd4f2bdb-2d56-4d0b-9880-743028cc9839.webp",
    popular: false,
    newArrival: true,
  }
];

export const customerGallery = [
  { id: 1, image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1792.webp", alt: "3D printet produkt" },
  { id: 2, image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/6ebb9be5-da2b-4687-b914-047293eacd06.webp", alt: "3D printet produkt" },
  { id: 3, image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1549.webp", alt: "3D printet produkt" },
  { id: 4, image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1994.webp", alt: "3D printet produkt" },
  { id: 5, image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-1667.webp", alt: "3D printet produkt" },
  { id: 6, image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image2-2.webp", alt: "3D printet produkt" },
  { id: 7, image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/img-1507.webp", alt: "3D printet produkt" },
  { id: 8, image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image2-3.webp", alt: "3D printet produkt" },
  { id: 9, image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/1eb83007-ae32-4031-b0d3-bf26d30bfc7a.webp", alt: "3D printet produkt" },
  { id: 10, image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-img-5428.webp", alt: "3D printet produkt" },
  { id: 11, image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/image3.webp", alt: "3D printet produkt" },
  { id: 12, image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5f0e3402-9702-46e9-9f88-0723f6de1e90/thumbnail-image1-1.webp", alt: "3D printet produkt" },
];

export const services = [
  {
    id: "3d-design",
    title: "3D Design",
    description: "Fra en simpel skitse til en fuldt færdig 3D-model. Vi skaber præcise designs, der er optimeret til produktion, uanset om det er til hobby eller erhverv.",
    icon: "PenTool",
  },
  {
    id: "custom-tasks",
    title: "Specialdesign / custom opgaver",
    description: "Har du en unik idé? Vi elsker udfordringer og specialiserer os i at skabe skræddersyede løsninger, der passer præcis til dine behov og ønsker.",
    icon: "Settings",
  },
  {
    id: "production",
    title: "Produktion / Print",
    description: "Vi tilbyder fleksibel produktion med fokus på kvalitet. Fra prototyper til små serier – vi printer i et bredt udvalg af materialer og farver.",
    icon: "Printer",
  }
];

export const categories = ["Alle", "Øl kasser med logo", "Kasser", "Gavebox", "Nøgleringe", "Figurer", "Lys / Lamper", "WC/Udstyr", "Køkken/Udstyr", "Andet"];
